import { sanitizeBoolString, sanitizeString } from '../utils';
import { ClientRequestType, ServerRequestType } from './types';

export const transformAccidentChallengeRequest = (
  data: ClientRequestType
): ServerRequestType => {
  return data.challengeType === 'edit'
    ? {
        atFault: sanitizeBoolString(data.atFault),
        month: sanitizeString(data.month),
        day: sanitizeString(data.day ?? ''),
        year: sanitizeString(data.year),
        challengeReason: 'edit_with_proof',
        reasonText: sanitizeString(data.reasonText),
        accidentType: sanitizeString(data.accidentType ?? ''),
        lossAmount: sanitizeString(data.lossAmount ?? ''),
        operatorId: sanitizeString(data.operatorId ?? ''),
      }
    : {
        challengeReason: sanitizeString(data.challengeReason),
        reasonText: sanitizeString(data.reasonText),
      };
};
